import React from "react";
import "@fontsource/rajdhani/700.css";
import { Link as RouterLink } from "react-router-dom";

import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";

const Home = () => {
  return (
    <Box bg="#0A0A0A" color="white">
      {/* HERO SECTION */}
      <Box
        position="relative"
        minHeight={{ lg: "100vh" }}
        backgroundImage="url('/images/HighresScreenshot00003.png')"
        backgroundSize="cover"
        backgroundPosition="center"
        alt="Velocity Protocol Background"
      >
        {/* DARK OVERLAY */}
        <Box
          position="absolute"
          inset={0}
          bg="rgba(0,0,0,.5)"
          zIndex={1}
        />

        <Container
          maxW="container.xl"
          position="relative"
          zIndex={2}
        >
          <Flex
            minHeight={{ lg: "100vh" }}
            align="center"
            justify="space-between"
            direction={{ base: "column", lg: "row" }}
            gap={10}
            py={20}
          >
            {/* LEFT SIDE */}
            <Stack spacing={6} maxW="600px">
              <Text
                fontSize="sm"
                letterSpacing="0.25em"
                textTransform="uppercase"
                color="gray.400"
              >
                Fast-Paced Rogue-Lite Movement Shooter
              </Text>

              {/* GAME TITLE */}
              <Heading
                fontSize={{ base: "5xl", md: "7xl" }}
                lineHeight="0.95"
                fontWeight="700"
                fontFamily="'Rajdhani', sans-serif"
                textTransform="uppercase"
              >
                Velocity Protocol
              </Heading>

              <Text
                fontSize={{ base: "md", md: "xl" }}
                color="gray.300"
              >
                Wallrun, slide, air-strafe, and fight through hostile
                sci-fi biomes in a high-speed roguelike built around
                momentum and flow.
              </Text>

              <Flex gap={4} wrap="wrap">
                <Button
                  as={RouterLink}
                  to="/download"
                  size="lg"
                  bg="white"
                  color="black"
                  _hover={{ bg: "gray.400" }}
                >
                  Download Demo
                </Button>

                <Button
                  as="a"
                  href="https://www.youtube.com/watch?v=vFbwIWYkDDs"
                  target="_blank"
                  rel="noopener noreferrer"
                  size="lg"
                  bg="grey"
                  borderColor="whiteAlpha.400"
                  _hover={{ bg: "red.800" }}
                  color="white"
                >
                  Watch Trailer
                </Button>
              </Flex>
            </Stack>

            {/* TRAILER PLACEHOLDER */}
              <Box
                width={{ base: "100%", lg: "650px" }}
                maxWidth="650px"
                aspectRatio={16 / 9}
                flexShrink={0}
                bg="blackAlpha.700"
                border="1px solid"
                borderColor="whiteAlpha.300"
                borderRadius="20px"
                overflow="hidden"
                boxShadow="0 0 40px rgba(0,0,0,0.5)"
              >
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/vFbwIWYkDDs"
                  title="Velocity Protocol Trailer"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ border: "none", display: "block" }}
                />
              </Box>
          </Flex>
        </Container>
      </Box>

      {/* DEMO CTA SECTION */}
      <Box py={28} borderTop="1px solid rgba(255,255,255,0.08)">
        <Container maxW="container.lg" textAlign="center">
          <Stack spacing={6}>
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              fontFamily="'Rajdhani', sans-serif"
              textTransform="uppercase"
            >
              Play the Demo
            </Heading>

            <Text
              maxW="700px"
              mx="auto"
              color="gray.400"
              fontSize={{ base: "md", md: "lg" }}
            >
              Experience the movement system, fast-paced combat,
              and roguelike gameplay loop in the early playable demo.
            </Text>

            <Box>
              <Button
                as={RouterLink}
                to="/download"
                size="lg"
                px={10}
                bg="white"
                color="black"
                _hover={{ bg: "gray.300" }}
              >
                Download for Windows
              </Button>
            </Box>

            <Text color="gray.500" fontSize="sm">
              Free Demo | Windows | Public Alpha Build
            </Text>
          </Stack>
        </Container>
      </Box>

      {/* ABOUT SECTION */}
      <Box py={28} borderTop="1px solid rgba(255,255,255,0.08)">
        <Container maxW="container.xl">
          <Stack spacing={10}>
            <Box textAlign="center">
              <Heading
                mb={6}
                fontSize={{ base: "3xl", md: "5xl" }}
                fontFamily="'Rajdhani', sans-serif"
                textTransform="uppercase"
              >
                About the Game
              </Heading>

              <Text
                maxW="850px"
                mx="auto"
                color="gray.400"
                fontSize={{ base: "md", md: "lg" }}
                lineHeight="1.9"
              >
                Velocity Protocol is a high-speed rogue-lite movement-shooter
                 focused on flow, momentum, and aggressive
                mobility. Chain together wallruns, slides, double jumps,
                and air-strafes while fighting through futuristic combat
                arenas filled with deadly enemies, powerful weapons,
                and evolving upgrades.
              </Text>
            </Box>

            {/* GIFS */}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
              <Box
                borderRadius="20px"
                overflow="hidden"
                border="1px solid rgba(255,255,255,0.08)"
              >
                <Image
                  src="/images/gameplayGIF1.gif"
                  alt="Movement Gameplay"
                  width="100%"
                />
              </Box>

              <Box
                borderRadius="20px"
                overflow="hidden"
                border="1px solid rgba(255,255,255,0.08)"
              >
                <Image
                  src="/images/GameplayGIF2.gif"
                  alt="Combat Gameplay"
                  width="100%"
                />
              </Box>
            </SimpleGrid>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
